import React from 'react';
import ConfirmModal from '../Common/ConfirmModal';

export function ClassificationBulkDeleteToolbar({ bulk }) {
  if (!bulk?.showBulkDelete) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 mb-3">
      <button
        type="button"
        onClick={bulk.toggleSelectAll}
        className="px-3 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
      >
        {bulk.allDeletableSelected ? 'Quitar selección' : 'Seleccionar eliminables'}
      </button>
      {bulk.selectedCount > 0 ? (
        <button
          type="button"
          onClick={bulk.openConfirm}
          className="px-3 py-2 border border-red-300 rounded-md text-sm font-medium text-red-700 bg-red-50 hover:bg-red-100"
        >
          Borrar seleccionados ({bulk.selectedCount})
        </button>
      ) : null}
    </div>
  );
}

export function ClassificationBulkDeleteTh({ bulk }) {
  if (!bulk?.showColumn) return null;
  return (
    <th className="px-4 py-3 text-left w-10">
      <input
        type="checkbox"
        checked={bulk.allDeletableSelected}
        onChange={bulk.toggleSelectAll}
        aria-label="Seleccionar todos los eliminables"
        className="rounded border-gray-300 text-teal-600 focus:ring-teal-500"
      />
    </th>
  );
}

export function ClassificationBulkDeleteTd({ bulk, row }) {
  if (!bulk?.showColumn) return null;
  const selectable = bulk.isSelectable(row);
  return (
    <td className="px-4 py-4 whitespace-nowrap w-10">
      {selectable ? (
        <input
          type="checkbox"
          checked={bulk.isSelected(row.id)}
          onChange={() => bulk.toggleRow(row)}
          aria-label={`Seleccionar ${row.name}`}
          className="rounded border-gray-300 text-teal-600 focus:ring-teal-500"
        />
      ) : null}
    </td>
  );
}

export function ClassificationBulkDeleteModal({ bulk }) {
  if (!bulk?.showBulkDelete) return null;
  return (
    <ConfirmModal
      isOpen={bulk.confirmOpen}
      onClose={bulk.closeConfirm}
      onConfirm={bulk.executeBulkDelete}
      title="Borrado masivo"
      message={bulk.confirmMessage}
      confirmText={bulk.executing ? 'Eliminando…' : 'Eliminar'}
      cancelText="Cancelar"
      type="danger"
    />
  );
}
